import { useSearchParams } from 'react-router-dom';

import { formatDateTimeToKoreanWithWeekday, formatDateToKoreanWithWeekday } from 'shared/lib';

import { usePostPayDetailStatementRequest } from '../model';

import SaveSkipFooter from './Button';
import './issue.css';

export const Issue = () => {
  const [searchParams] = useSearchParams();
  const { mutate: postPayDetailStatementRequest } = usePostPayDetailStatementRequest();

  const ptNm = searchParams.get('ptNm');
  const deptNm = searchParams.get('deptNm');
  const medicalInsuranceSchedule = searchParams.get('medicalInsuranceSchedule');
  const receivePaymentPrice = searchParams.get('receivePaymentPrice');
  const paymentDateTime = searchParams.get('paymentDateTime');

  const formattedMedicalInsuranceSchedule = formatDateToKoreanWithWeekday(medicalInsuranceSchedule);
  const formattedPaymentDateTime = formatDateTimeToKoreanWithWeekday(paymentDateTime);

  return (
    <div className='container-wrap receipt-container'>
      <div className='title-wrap'>
        <h2>
          진료비에 대한 세부내역서를
          <br />
          발급받을 수 있어요
        </h2>
        <p className='desc'>진료비 세부내역서를 발급 받으시면 항목별 진료비 정보를 자세히 확인하실 수 있어요.</p>
      </div>
      <div className='receipt-billing-info'>
        <div className='badge'>진료비 결제 정보</div>
        <div className='info'>
          <span>환자명</span>
          <span>{ptNm}</span>
        </div>
        <div className='info'>
          <span>진료과</span>
          <span>{deptNm}</span>
        </div>
        <div className='info'>
          <span>진료일</span>
          <span>{formattedMedicalInsuranceSchedule}</span>
        </div>
        <div className='info'>
          <span>결제금액</span>
          <span>{parseInt(receivePaymentPrice).toLocaleString()}원</span>
        </div>
        <div className='info no-wrap'>
          <span>결제일시</span>
          <span>
            {formattedPaymentDateTime.date}
            <wbr /> {formattedPaymentDateTime.time}
          </span>
        </div>
      </div>
      <SaveSkipFooter
        text='발급하기'
        isValid
        textStyle='btn-txt-02'
        handleClick={() => {
          postPayDetailStatementRequest({
            hspId: '13',
            mpiKey: 'MAMFKEMJ17592196PGLCKAKA01LCNE572986A85F',
            receivePaymentId: '10136797911001',
            medicalInsuranceType: 'O',
          });
        }}
        handleSkip={() => {
          window.location.href = 'kakaotalk://web/close';
        }}
      />
    </div>
  );

  // 추후 발급 성공 실패 모달 추가
};
